import _regenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      show: true,
      walletSite: ""
    };
  },
  methods: {
    getCurrentBTYAddress: function getCurrentBTYAddress() {
      var _this = this;
      jsBridge.getCurrentBTYAddress({}, function (v) {
        _this.$toast(v);
        _this.walletSite = v;
      });
      // jsBridge.call("getCurrentBTYAddress", function(v) {
      //   _this.$toast(v);
      //   _this.walletSite = v;
      // });
    },
    bindBTYAddress: function bindBTYAddress() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$$http$get, result, msg;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return $http.get("plugin.love-speed-pool.frontend.wallet-site.edit-info", {
                site: _this2.walletSite
              });
            case 1:
              _yield$$http$get = _context.v;
              result = _yield$$http$get.result;
              msg = _yield$$http$get.msg;
              _this2.$toast(msg);
              if (result == 1) _this2.show = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setCloneWalletBind: function setCloneWalletBind() {
      localStorage.setItem("isCloneWalletBind", true);
      location.reload();
    }
  }
};